const Team = target => {
  const $body = $('body')
  const $target = $body.find(target)
  const $filters = $target.find('.team__filters input')
  const $container = $body.find('.team__loop')
  const ajaxTeamMethod = `query_${$target.data('action')}_content`
  const ajaxPartnerMethod = 'query_partner_modal_content'
  const ajaxModal = data => {
    $.ajax({
      // eslint-disable-next-line no-undef
      url: ajax_object.ajax_url,
      method: 'POST',
      data: data,
    }).done((response) => {
      const data = JSON.parse(response)
      // eslint-disable-next-line no-undef
      swal.fire({
        html: data.template,
        showCloseButton: true,
        closeButtonHtml: '<i class="icon icon-close"></i>',
        showConfirmButton: false,
      })
    })
  }

  const initModalPartner = () => {
    $('body').find('.js-entry-partner').on('click', evt => {
      evt.preventDefault()
      const $el = $(evt.currentTarget)
      const data = {
        action: ajaxPartnerMethod,
        // eslint-disable-next-line no-undef
        security: ajax_object.ajax_nonce,
        id: $el.data('id'),
      }
      ajaxModal(data)
    })
  }

  const ajaxRequest = data => {
    $.ajax({
      // eslint-disable-next-line no-undef
      url: ajax_object.ajax_url,
      method: 'POST',
      data: data,
    }).done((response) => {
      const res = JSON.parse(response)
      $container.html(res.template)
      $container.attr('class', 'team__loop')
      $container.addClass(`team__loop--${data.type}`)
      if ($('body').find('.js-entry-partner').length) {
        initModalPartner()
      }
    })
  }

  const initTeam = () => {
    // Ouverture modale
    $filters.on('change', e => {
      e.preventDefault()
      const $el = $(e.currentTarget)
      const data = {
        action: ajaxTeamMethod,
        // eslint-disable-next-line no-undef
        security: ajax_object.ajax_nonce,
        slug: $el.val(),
        type: $el.data('type'),
      }
      ajaxRequest(data)
    })
  }

  if ($target.length) {
    initTeam()
  }
}

export default Team;



// WEBPACK FOOTER //
// ./scripts/components/Team.js